import Image from '@tiptap/extension-image';

/**
 * TipTap Image with stable MinIO identifiers for persist/reload.
 * Persisted HTML uses data-file-key / data-attachment-id; src is display-only (blob:).
 * Must parse `img[data-file-key]` even when src was stripped on save — default Image only matches img[src].
 */
export const FileKeyImage = Image.extend({
    name: 'image',
    addAttributes() {
        return {
            ...this.parent?.(),
            src: {
                default: null,
            },
            alt: {
                default: null,
            },
            title: {
                default: null,
            },
            fileKey: {
                default: null,
                parseHTML: (element: HTMLElement) => element.getAttribute('data-file-key'),
                renderHTML: (attributes: { fileKey?: string | null }) => {
                    if (!attributes.fileKey) return {};
                    return { 'data-file-key': attributes.fileKey };
                },
            },
            attachmentId: {
                default: null,
                parseHTML: (element: HTMLElement) => element.getAttribute('data-attachment-id'),
                renderHTML: (attributes: { attachmentId?: string | null }) => {
                    if (!attributes.attachmentId) return {};
                    return { 'data-attachment-id': attributes.attachmentId };
                },
            },
        };
    },
    parseHTML() {
        return [
            { tag: 'img[data-file-key]' },
            {
                tag: this.options.allowBase64
                    ? 'img[src]'
                    : 'img[src]:not([src^="data:"])',
            },
        ];
    },
});
